export const binOperationTime = "binoperationtime";
export const months = "months";
export const monday = "monday";
export const tuesday = "tuesday";
export const wednesday = "wednesday";
export const thursday = "thursday";
export const friday = "friday";
export const saturday = "saturday";
export const sunday = "sunday";
